module.exports = __webpack_public_path__ + "img/delete-row-img.85b9dada.svg";